import { Pipe, PipeTransform } from '@angular/core';
//import { ClassroomSummary } from '../../classroom-summary/models/classroom-summary.model';
import { LoginService } from '../../../shared-modules/login/login.service';
import { ClassroomSummary } from '../../../classroom360/classroom-summary/models/classroom-summary.model';

@Pipe({
    name: 'selectRecipients',
    pure: false
})
export class SelectRecipientsPipe implements PipeTransform {
    selectedClasses: ClassroomSummary[] = [];

    constructor(private loginService: LoginService) { }

    transform(subject: any, filter: any[], referringPage: string): any {
        const obj: any[] = [];
        if (filter != null) {
            for (let i = 0; i < filter.length; i++) {
                switch (referringPage) {
                    case 'My Classes':
                        if (this.loginService.LoginSettings.V10 == true && subject.find(x => x.SSEC_ID == filter[i])) {
                            obj.push(subject.find(x => x.SSEC_ID == filter[i]));
                        }
                        if (this.loginService.LoginSettings.V10 != true && subject.find(x => x.Id == filter[i])) {
                            obj.push(subject.find(x => x.Id == filter[i]));
                        }
                        break;

                    case 'Student Teams':
                        if (subject.find(x => x.Id == filter[i])) {
                            obj.push(subject.find(x => x.Id == filter[i]));
                        }
                        break;

                    case 'Student Lists':
                        if (subject.find(x => x.ID == filter[i])) {
                            obj.push(subject.find(x => x.ID == filter[i]));
                        }
                        break;
                }
            }
        }
        return obj;
    }

}




